import React, { Component } from "react";
import httpService from "../../services/httpService";
import config from "../../config.json";
import { Table } from "react-bootstrap";
import { Modal } from "react-bootstrap";
import { Button } from "react-bootstrap";

class FirmyVypis extends Component {
  state = { novaFirma: {} };

  componentDidMount = () => {
    this.nahrajFirmy();
  };

  nahrajFirmy = async () => {
    const firmy = await httpService.post(
      config.apiEndpoint + "firmy/vypis.php"
    );
    this.setState({
      loaded: true,
      firmy: firmy.data.firmy,
      ordinace: firmy.data.ordinace,
    });
  };

  novaFirma = async () => {
    const { novaFirma } = this.state;
    await httpService.post(config.apiEndpoint + "firmy/novaFirma.php", {
      novaFirma,
    });
    this.nahrajFirmy();
    this.setState({ novaFirma: {}, novaFirmaShow: false });
  };

  novaFirmaOrdinace = (ordinace_id, checked) => {
    let { novaFirma } = this.state;
    if (checked) {
      if (!novaFirma.ordinace) {
        novaFirma.ordinace = [];
      }
      novaFirma.ordinace.push(ordinace_id);
    } else {
      novaFirma.ordinace = novaFirma.ordinace.filter((o) => o !== ordinace_id);
    }
    this.setState({ novaFirma });
  };

  zmenaFirma = async (attr, val, send) => {
    let { firmy } = this.state;
    const { editFirmaID } = this.state;
    const index = firmy.findIndex((f) => f.firma_id === editFirmaID);
    firmy[index][attr] = val;
    this.setState({ firmy });
    if (send) {
      httpService.post(config.apiEndpoint + "firmy/zmenaDetail.php", {
        firma_id: editFirmaID,
        attr,
        val,
      });
    }
  };

  firmaOrdinace = (ordinace_id, checked) => {
    let { firmy } = this.state;
    const { editFirmaID } = this.state;
    const index = firmy.findIndex((f) => f.firma_id === editFirmaID);
    if (!firmy[index].ordinace) {
      firmy[index].ordinace = [];
    }
    if (checked) {
      firmy[index].ordinace.push(ordinace_id);
    } else {
      firmy[index].ordinace = firmy[index].ordinace.filter(
        (o) => o !== ordinace_id
      );
    }
    this.setState({ ordinace_id });
    httpService.post(config.apiEndpoint + "firmy/ordinaceAdd.php", {
      firma_id: editFirmaID,
      ordinace_id,
      checked: checked ? 1 : 0,
    });
  };

  render() {
    const {
      loaded,
      firmy,
      ordinace,
      novaFirmaShow,
      novaFirma,
      editFirmaID,
    } = this.state;
    let firma = {};
    if (editFirmaID) {
      const index = firmy.findIndex((f) => f.firma_id === editFirmaID);
      firma = firmy[index];
    }
    return (
      <React.Fragment>
        {loaded ? (
          <React.Fragment>
            <Modal
              onHide={() => this.setState({ novaFirmaShow: false })}
              show={novaFirmaShow}
              dialogClassName="modal-90w"
            >
              <Modal.Header closeButton>
                Nový zaměstnavatel / pobočka
              </Modal.Header>
              <Modal.Body>
                <div className="row">
                  <div className="col-md-6">
                    <h4>Informace o společnosti</h4>
                    <div className="row">
                      <div className="col-md-4">
                        <input
                          type="text"
                          name="nazev"
                          value={novaFirma.nazev}
                          placeholder="Název místa/pobočky"
                          className="form-control mb-3"
                          onChange={(e) =>
                            this.setState({
                              novaFirma: {
                                ...novaFirma,
                                [e.target.name]: e.target.value,
                              },
                            })
                          }
                        />
                      </div>
                      <div className="col-md-4">
                        <input
                          type="text"
                          name="nazevSpolecnosti"
                          value={novaFirma.nazevSpolecnosti}
                          placeholder="Název společnosti"
                          className="form-control mb-3"
                          onChange={(e) =>
                            this.setState({
                              novaFirma: {
                                ...novaFirma,
                                [e.target.name]: e.target.value,
                              },
                            })
                          }
                        />
                      </div>
                      <div className="col-md-4">
                        <input
                          type="text"
                          name="ic"
                          value={novaFirma.ic}
                          placeholder="IČ"
                          className="form-control mb-3"
                          onChange={(e) =>
                            this.setState({
                              novaFirma: {
                                ...novaFirma,
                                [e.target.name]: e.target.value,
                              },
                            })
                          }
                        />
                      </div>
                      <div className="col-md-4">
                        <input
                          type="text"
                          name="voj"
                          value={novaFirma.voj}
                          placeholder="VOJ společnosti"
                          className="form-control mb-3"
                          onChange={(e) =>
                            this.setState({
                              novaFirma: {
                                ...novaFirma,
                                [e.target.name]: e.target.value,
                              },
                            })
                          }
                        />
                      </div>
                      <div className="col-md-4">
                        <input
                          type="text"
                          name="bankovniUcet"
                          value={novaFirma.bankovniUcet}
                          placeholder="Bankovní účet"
                          className="form-control mb-3"
                          onChange={(e) =>
                            this.setState({
                              novaFirma: {
                                ...novaFirma,
                                [e.target.name]: e.target.value,
                              },
                            })
                          }
                        />
                      </div>
                      <div className="col-md-4">
                        <input
                          type="text"
                          name="ulice"
                          value={novaFirma.ulice}
                          placeholder="Ulice"
                          className="form-control mb-3"
                          onChange={(e) =>
                            this.setState({
                              novaFirma: {
                                ...novaFirma,
                                [e.target.name]: e.target.value,
                              },
                            })
                          }
                        />
                      </div>
                      <div className="col-md-4">
                        <input
                          type="text"
                          name="mesto"
                          value={novaFirma.mesto}
                          placeholder="Město"
                          className="form-control mb-3"
                          onChange={(e) =>
                            this.setState({
                              novaFirma: {
                                ...novaFirma,
                                [e.target.name]: e.target.value,
                              },
                            })
                          }
                        />
                      </div>
                      <div className="col-md-4">
                        <input
                          type="text"
                          name="psc"
                          value={novaFirma.psc}
                          placeholder="PSČ"
                          className="form-control mb-3"
                          onChange={(e) =>
                            this.setState({
                              novaFirma: {
                                ...novaFirma,
                                [e.target.name]: e.target.value,
                              },
                            })
                          }
                        />
                      </div>
                      <div className="col-md-4">
                        <input
                          type="text"
                          name="telefonKomunikace"
                          value={novaFirma.telefonKomunikace}
                          placeholder="Telefonní číslo"
                          className="form-control mb-3"
                          onChange={(e) =>
                            this.setState({
                              novaFirma: {
                                ...novaFirma,
                                [e.target.name]: e.target.value,
                              },
                            })
                          }
                        />
                      </div>
                      <div className="col-md-4">
                        <input
                          type="text"
                          name="emailKomunikace"
                          value={novaFirma.emailKomunikace}
                          placeholder="E-mail"
                          className="form-control mb-3"
                          onChange={(e) =>
                            this.setState({
                              novaFirma: {
                                ...novaFirma,
                                [e.target.name]: e.target.value,
                              },
                            })
                          }
                        />
                      </div>
                      <div className="col-md-4">
                        <input
                          type="text"
                          name="telefonOvereni"
                          value={novaFirma.telefonOvereni}
                          placeholder="Telefon - personalista"
                          className="form-control mb-3"
                          onChange={(e) =>
                            this.setState({
                              novaFirma: {
                                ...novaFirma,
                                [e.target.name]: e.target.value,
                              },
                            })
                          }
                        />
                      </div>
                      <div className="col-md-4">
                        <div>
                          <input
                            type="checkbox"
                            name="potvrzeniZamestnani"
                            checked={novaFirma.potvrzeniZamestnani === "1"}
                            onChange={(e) =>
                              this.setState({
                                novaFirma: {
                                  ...novaFirma,
                                  [e.target.name]: e.target.checked ? "1" : "0",
                                },
                              })
                            }
                          />{" "}
                          Zobrazit v aplikaci potvrzeni o zaměstnání
                        </div>
                        <div>
                          <input
                            type="checkbox"
                            name="posilatSMS"
                            checked={novaFirma.posilatSMS === "1"}
                            onChange={(e) =>
                              this.setState({
                                novaFirma: {
                                  ...novaFirma,
                                  [e.target.name]: e.target.checked ? "1" : "0",
                                },
                              })
                            }
                          />{" "}
                          Posílat SMS
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <h4>
                      Testovací místa, kde se smí zaměstnanci hlásit na test
                    </h4>
                    <div className="row">
                      {ordinace &&
                        ordinace.map((o) => (
                          <div className="col-md-6 mb-3" key={o.ordinace_id}>
                            <input
                              type="checkbox"
                              checked={
                                novaFirma.ordinace &&
                                novaFirma.ordinace.findIndex(
                                  (o2) => o2 === o.ordinace_id
                                ) >= 0
                              }
                              onChange={(e) =>
                                this.novaFirmaOrdinace(
                                  o.ordinace_id,
                                  e.target.checked
                                )
                              }
                            />{" "}
                            {o.nazev}
                          </div>
                        ))}
                    </div>
                  </div>
                </div>
              </Modal.Body>
              <Modal.Footer>
                <Button
                  onClick={this.novaFirma}
                  disabled={
                    !(
                      novaFirma.nazev &&
                      novaFirma.nazevSpolecnosti &&
                      novaFirma.nazev !== "" &&
                      novaFirma.nazevSpolecnosti !== ""
                    )
                  }
                >
                  Vytvořit nové místo
                </Button>
              </Modal.Footer>
            </Modal>
            <Modal
              onHide={() => this.setState({ editFirmaID: false })}
              show={editFirmaID}
              dialogClassName="modal-90w"
            >
              <Modal.Header closeButton>Editace firmy</Modal.Header>
              <Modal.Body>
                <div className="row">
                  <div className="col-md-6">
                    <h4>Informace o společnosti</h4>
                    <div className="row">
                      <div className="col-md-4">
                        <input
                          type="text"
                          name="nazev"
                          value={firma.nazev}
                          placeholder="Název místa/pobočky"
                          className="form-control mb-3"
                          onChange={(e) =>
                            this.zmenaFirma(
                              e.target.name,
                              e.target.value,
                              false
                            )
                          }
                          onBlur={(e) =>
                            this.zmenaFirma(e.target.name, e.target.value, true)
                          }
                        />
                      </div>
                      <div className="col-md-4">
                        <input
                          type="text"
                          name="nazevSpolecnosti"
                          value={firma.nazevSpolecnosti}
                          placeholder="Název společnosti"
                          className="form-control mb-3"
                          onChange={(e) =>
                            this.zmenaFirma(
                              e.target.name,
                              e.target.value,
                              false
                            )
                          }
                          onBlur={(e) =>
                            this.zmenaFirma(e.target.name, e.target.value, true)
                          }
                        />
                      </div>
                      <div className="col-md-4">
                        <input
                          type="text"
                          name="ic"
                          value={firma.ic}
                          placeholder="IČ"
                          className="form-control mb-3"
                          onChange={(e) =>
                            this.zmenaFirma(
                              e.target.name,
                              e.target.value,
                              false
                            )
                          }
                          onBlur={(e) =>
                            this.zmenaFirma(e.target.name, e.target.value, true)
                          }
                        />
                      </div>
                      <div className="col-md-4">
                        <input
                          type="text"
                          name="voj"
                          value={firma.voj}
                          placeholder="VOJ společnosti"
                          className="form-control mb-3"
                          onChange={(e) =>
                            this.zmenaFirma(
                              e.target.name,
                              e.target.value,
                              false
                            )
                          }
                          onBlur={(e) =>
                            this.zmenaFirma(e.target.name, e.target.value, true)
                          }
                        />
                      </div>
                      <div className="col-md-4">
                        <input
                          type="text"
                          name="bankovniUcet"
                          value={firma.bankovniUcet}
                          placeholder="Bankovní účet"
                          className="form-control mb-3"
                          onChange={(e) =>
                            this.zmenaFirma(
                              e.target.name,
                              e.target.value,
                              false
                            )
                          }
                          onBlur={(e) =>
                            this.zmenaFirma(e.target.name, e.target.value, true)
                          }
                        />
                      </div>
                      <div className="col-md-4">
                        <input
                          type="text"
                          name="ulice"
                          value={firma.ulice}
                          placeholder="Ulice"
                          className="form-control mb-3"
                          onChange={(e) =>
                            this.zmenaFirma(
                              e.target.name,
                              e.target.value,
                              false
                            )
                          }
                          onBlur={(e) =>
                            this.zmenaFirma(e.target.name, e.target.value, true)
                          }
                        />
                      </div>
                      <div className="col-md-4">
                        <input
                          type="text"
                          name="mesto"
                          value={firma.mesto}
                          placeholder="Město"
                          className="form-control mb-3"
                          onChange={(e) =>
                            this.zmenaFirma(
                              e.target.name,
                              e.target.value,
                              false
                            )
                          }
                          onBlur={(e) =>
                            this.zmenaFirma(e.target.name, e.target.value, true)
                          }
                        />
                      </div>
                      <div className="col-md-4">
                        <input
                          type="text"
                          name="psc"
                          value={firma.psc}
                          placeholder="PSČ"
                          className="form-control mb-3"
                          onChange={(e) =>
                            this.zmenaFirma(
                              e.target.name,
                              e.target.value,
                              false
                            )
                          }
                          onBlur={(e) =>
                            this.zmenaFirma(e.target.name, e.target.value, true)
                          }
                        />
                      </div>
                      <div className="col-md-4">
                        <input
                          type="text"
                          name="telefonKomunikace"
                          value={firma.telefonKomunikace}
                          placeholder="Telefonní číslo"
                          className="form-control mb-3"
                          onChange={(e) =>
                            this.zmenaFirma(
                              e.target.name,
                              e.target.value,
                              false
                            )
                          }
                          onBlur={(e) =>
                            this.zmenaFirma(e.target.name, e.target.value, true)
                          }
                        />
                      </div>
                      <div className="col-md-4">
                        <input
                          type="text"
                          name="emailKomunikace"
                          value={firma.emailKomunikace}
                          placeholder="E-mail"
                          className="form-control mb-3"
                          onChange={(e) =>
                            this.zmenaFirma(
                              e.target.name,
                              e.target.value,
                              false
                            )
                          }
                          onBlur={(e) =>
                            this.zmenaFirma(e.target.name, e.target.value, true)
                          }
                        />
                      </div>
                      <div className="col-md-4">
                        <input
                          type="text"
                          name="telefonOvereni"
                          value={firma.telefonOvereni}
                          placeholder="Telefon - personalista"
                          className="form-control mb-3"
                          onChange={(e) =>
                            this.zmenaFirma(
                              e.target.name,
                              e.target.value,
                              false
                            )
                          }
                          onBlur={(e) =>
                            this.zmenaFirma(e.target.name, e.target.value, true)
                          }
                        />
                      </div>
                      <div className="col-md-4">
                        <div>
                          <input
                            type="checkbox"
                            name="potvrzeniZamestnani"
                            checked={firma.potvrzeniZamestnani === "1"}
                            onChange={(e) =>
                              this.zmenaFirma(
                                e.target.name,
                                e.target.checked ? "1" : "0",
                                true
                              )
                            }
                          />{" "}
                          Zobrazit v aplikaci potvrzeni o zaměstnání
                        </div>
                        <div>
                          <input
                            type="checkbox"
                            name="posilatSMS"
                            checked={firma.posilatSMS === "1"}
                            onChange={(e) =>
                              this.zmenaFirma(
                                e.target.name,
                                e.target.checked ? "1" : "0",
                                true
                              )
                            }
                          />{" "}
                          Posílat SMS
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <h4>
                      Testovací místa, kde se smí zaměstnanci hlásit na test
                    </h4>
                    <div className="row">
                      {ordinace &&
                        ordinace.map((o) => (
                          <div className="col-md-6 mb-3" key={o.ordinace_id}>
                            <input
                              type="checkbox"
                              checked={
                                firma.ordinace &&
                                firma.ordinace.findIndex(
                                  (o2) => o2 === o.ordinace_id
                                ) >= 0
                              }
                              onChange={(e) =>
                                this.firmaOrdinace(
                                  o.ordinace_id,
                                  e.target.checked
                                )
                              }
                            />{" "}
                            {o.nazev}
                          </div>
                        ))}
                    </div>
                  </div>
                </div>
              </Modal.Body>
            </Modal>
            <Button onClick={() => this.setState({ novaFirmaShow: true })}>
              Nový zaměstnavatel / Místo
            </Button>
            <Table className="mt-3">
              <thead>
                <tr>
                  <th>Název místa</th>
                  <th>Název společnosti</th>
                  <th>Počet zaměstnanců</th>
                </tr>
              </thead>
              <tbody>
                {firmy &&
                  firmy.map((f) => (
                    <tr key={f.firma_id}>
                      <td>
                        <Button
                          variant="link"
                          style={{ padding: "0px", margin: "0px" }}
                          onClick={() =>
                            this.setState({ editFirmaID: f.firma_id })
                          }
                        >
                          {f.nazev}
                        </Button>
                      </td>
                      <td>{f.nazevSpolecnosti}</td>
                      <td>{f.pocet}</td>
                    </tr>
                  ))}
              </tbody>
            </Table>
          </React.Fragment>
        ) : (
          "Loading..."
        )}
      </React.Fragment>
    );
  }
}

export default FirmyVypis;
